import { post } from 'axios'
import store from './../../store/index.js'

const BASE_URL = store.state.api.baseUrl
const headers = { Authorization: `Bearer ${store.state.user.attributes.token}` }

// put
function talkScheduleUpdateSchedule (pFormData, pIdTalkSchedule) {
    const URI = `${BASE_URL}/api/talkSchedules/${pIdTalkSchedule}/updateSchedule`
    return post(URI, pFormData, { headers })
}

export { talkScheduleUpdateSchedule }